<!-- 通知 -->
<div class="right-aside">
  <ng-container *ngTemplateOutlet="noticeTemplate"></ng-container>
</div>

<!-- 新增 通知 -->
<ng-template #noticeTemplate>
  <div class="notice-header">
    <span class="title">{{ 'noti' | translate }}</span>
    <i class="icon-error close-anim mutual-opacity" (click)="closeRightAside()"></i>
  </div>
  <div class="notice-nav">
    <ng-container *ngFor="let item of noticeNavList; let index = index">
      <customize-button
        [class.active-bgc]="selectedNoticeIndex === index"
        radius="0"
        size="large-medium"
        width="100%"
        type="text-normal"
        (onClick)="selectedNoticeIndex = index; onInitNoticePopup()"
      >
        <span [class.active]="selectedNoticeIndex === index" class="btn-title"> {{ item.title }}</span>
        <p class="notice-number" *ngIf="item.msg > 0">{{ item.msg > 99 ? '99+' : item.msg }}</p>
      </customize-button>
    </ng-container>
  </div>
  <app-scrollbar>
    <div class="notice-content" [appLoading]="noticePupupLoading">
      <ng-container [ngSwitch]="selectedNoticeIndex">
        <ng-container *ngSwitchCase="0">
          <div class="top-tools">
            <!--隐藏已读-->
            <div [class.active]="data.isHiddenReadedMsg">
              <mat-checkbox
                class="is-readed-msg onact96"
                [checked]="data.isHiddenReadedMsg"
                (change)="onHiddenReadedMsg()"
              >
                <span class="max-box-text">{{ 'hide_read' | translate }} </span>
              </mat-checkbox>
            </div>
            <!--全部已读 清除已读-->
            <div
              class="onact96"
              [class.active]="item.active"
              *ngFor="let item of iconLists; let i = index"
              (click)="onClickToolMeun(item, i)"
            >
              <i
                (mouseenter)="onShowTool(i)"
                (mouseleave)="onShowTool(-1)"
                class="mutual-opacity onact96 {{ item.iconName }}"
              ></i
              ><span class="name">{{ item.text | translate }}</span>
            </div>
          </div>
          <!--消息类型tab group-->
          <ng-container *ngTemplateOutlet="notificationTabTemplate"></ng-container>
          <div class="notice-content-container" *ngIf="allNotice.length > 0">
            <div class="notice" *ngFor="let item of allNotice; let index = index" (click)="onReadMsgCall(item, index)">
              <div class="header">
                <div class="title">
                  <p>{{ item.title }}</p>
                  <p class="dot" [ngClass]="{ 'green-dot': !item.isReaded }"></p>
                </div>
                <div class="bottom-container">
                  <div class="sender">
                    <!-- 品牌LOGO -->
                    <img class="log" [src]="getImageUrl(item.noticeType)" /><span class="name">{{
                      item.name | translate
                    }}</span>
                  </div>
                  <div class="time">{{ item.sendActTime }}</div>
                </div>
              </div>
              <div class="notice-body">
                <div class="welcome">
                  <img class="log" src="assets/svg/welcome.svg" />
                  <span class="name">
                    {{ 'welcome' | translate }} {{ userInfo.userName.length > 0 ? userInfo.userName : userInfo.uid }}
                  </span>
                </div>
                <div
                  *ngIf="item?.content"
                  #container
                  class="content"
                  [innerHTML]="item.content | remarkLink | toHtmlElement"
                ></div>
              </div>
            </div>
            <app-paginator
              [(page)]="notiPaginator.page"
              [total]="notiPaginator.total"
              [pageSize]="notiPaginator.pageSize"
              (onPageChange)="getNotificationData(true)"
              [alwaysH5]="true"
              [loading]="noticeLoading"
            ></app-paginator>
          </div>
          <app-empty class="mt-auto" *ngIf="allNotice.length === 0 && !noticePupupLoading"></app-empty>
        </ng-container>

        <ng-container *ngSwitchCase="1">
          <div class="notice-content-container" *ngIf="activities.length > 0">
            <div class="activity" *ngFor="let item of activities; let index = index">
              <div class="img-wrap">
                <div class="wrap">
                  <app-lazy-image [lazy]="item?.activityImgUrl || ''" [radius]="5"></app-lazy-image>
                </div>
              </div>
              <div class="bottom">
                <p class="activity-title">
                  {{ item.title }}
                </p>
                <customize-button
                  type="primary-linear"
                  size="large-medium"
                  minWidth="100px"
                  (onClick)="onRedirectActivityDetail(item)"
                >
                  {{ 'checked' | translate }}
                </customize-button>
              </div>
            </div>
          </div>
          <app-empty class="mt-auto" *ngIf="activities.length === 0 && !noticePupupLoading"></app-empty>
        </ng-container>
        <ng-container *ngSwitchCase="2">
          <div
            class="notice-content-container card-container"
            *ngIf="cardsList.length > 0"
            (intersectChange)="onOpenStickyModule($event)"
            [intersectionObserver]="true"
            [intersectionObserver-config]="{ offset: '0px 0px -120px 0px' }"
            [class.disabled]="collectAllLoading || cardLoading"
          >
            <div
              class="card"
              [class]="item.grantType.toLowerCase()"
              [class.mt-6]="index === 0"
              *ngFor="let item of cardsList; let index = index"
            >
              <p class="title">
                {{ item.title }}
              </p>
              <div class="money">
                <img class="icon-currency" [src]="item.currency | currencyIcon" />
                <p class="total">{{ item.amount | currencyValue: item?.currency || '' }}</p>
              </div>
              <div class="types">
                <div class="type" *ngIf="item.activityType === 'Vip'">{{ 'vip_exclusive' | translate }}</div>
                <div class="typeMoney" *ngFor="let label of item.labels">
                  {{ label }}
                </div>
              </div>
              <div class="date">
                <span>
                  {{ 'expiration_date' | translate }}
                </span>
                <span>{{ item.expiredTime | mdate: 'YYYY-MM-DD HH:mm:ss' }}</span>
              </div>
              <div class="status">
                <customize-button
                  type="primary-linear"
                  size="medium-small"
                  minWidth="100%"
                  [loading]="cardLoading && currentCardId === item.id"
                  [disabled]="cardLoading"
                  (onClick)="onClickOpenConfirmPopup(item.id)"
                >
                  {{ 'get_card' | translate }}
                </customize-button>
              </div>
            </div>
            <div class="ocupied-dom"></div>
            <div class="sticky-btn animate__animated animate__fadeInUp animate__faster sticky">
              <customize-button
                class="onact96-btn"
                size="large-medium"
                type="primary-linear"
                width="100%"
                [disabled]="noticeNavList[2].msg === 0 || collectAllLoading"
                [loading]="collectAllLoading"
                (onClick)="onBatchCards()"
                >{{ 'batch_cards' | translate }}</customize-button
              >
            </div>
          </div>
          <app-empty *ngIf="cardsList.length === 0 && !noticePupupLoading" [text]="'no_coupons_yet' | translate">
          </app-empty>
        </ng-container>
        <ng-container *ngSwitchCase="3">
          <app-daily-contest></app-daily-contest>
        </ng-container>
      </ng-container>
    </div>
  </app-scrollbar>
</ng-template>

<ng-template #notificationTabTemplate let-title="title" let-subThemeList="subThemeList">
  <div class="notification-mat-tab">
    <div class="select-input network">
      <app-scroll-select-item
        [data]="notificationNavList"
        [gap]="5"
        (clickTab)="selectNoticeItemMenu($event.index); onSelectNoticeTypeMenuItem($event, $event.index)"
      >
        <ng-template #item let-item="item" let-index="index">
          <div class="tab-item" [class.active]="selectNoticeItemIndex == index">
            {{ item.title }}
            <ng-container *ngIf="item.msg != 0"> ({{ item.msg }}) </ng-container>
          </div>
        </ng-template>
      </app-scroll-select-item>
    </div>
  </div>
</ng-template>
